import React, { useState } from 'react';
import {
  FaBars,
  FaTimes,
  FaGithub,
  FaLinkedin,
  
} from 'react-icons/fa';

import { HiOutlineMail } from 'react-icons/hi';
import { BsFillPersonLinesFill } from 'react-icons/bs';

import { Link } from 'react-scroll';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [activeElement, setActiveElement] = useState("");
  const handleClick = () => setNav(!nav);
  const handleSetActive = (to) => {
    setActiveElement(to); // Update the activeElement state when an element is in view
  };

  return (
    <div className='fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300'>
       <img
          src="https://ibbiza.s3.us-east-2.amazonaws.com/jk.png"
          alt="Logo"
          style={{ width: "46px" }}
        />

      {/* menu */}
      <ul className='hidden md:flex'>
        <li className=" nav-item">
          <Link to='home' smooth={true} duration={500}  activeClass="active" spy={true} onSetActive={handleSetActive}>
            Home
          </Link>
        </li>
        <li className=" nav-item">
          <Link to='about' smooth={true} duration={500}  activeClass="active" spy={true} onSetActive={handleSetActive}>
            About
          </Link>
        </li>
        <li className=" nav-item">
          <Link to='skills' smooth={true} duration={500}  activeClass="active" spy={true} onSetActive={handleSetActive}>
            Skills
          </Link>
        </li>
        <li className=" nav-item">
          <Link to='work' smooth={true} duration={500}  activeClass="active"spy={true}   offset={50} onSetActive={handleSetActive}>
            Work
          </Link>
        </li>
        <li className=" nav-item">
          <Link to='contact' smooth={true} duration={500}  activeClass="active" spy={true} onSetActive={handleSetActive}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Hamburger */}
      <div onClick={handleClick} className='md:hidden z-10'>
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile menu */}
      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center'
        }
      >
        <li className='py-6 text-4xl'>
          <Link onClick={handleClick} to='home' smooth={true} duration={500} activeClass="active" spy={true}>
            Home
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='about' smooth={true} duration={500}  activeClass="active" spy={true} onSetActive={handleSetActive}>
            About
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='skills' smooth={true} duration={500}  activeClass="active" spy={true} onSetActive={handleSetActive}>
            Skills
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='work' smooth={true} duration={500}  activeClass="active" spy={true}>
            Work
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='contact' smooth={true} duration={500}  activeClass="active" spy={true}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Social icons */}
      <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
        <ul>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='https://www.linkedin.com/in/josias-kabore'
            >
              Linkedin <FaLinkedin size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='https://github.com/jkabore'
            >
              Github <FaGithub size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#6fc2b0]'>
          <Link to="contact" smooth={true} duration={500}>
              Email <HiOutlineMail size={30} />
            </Link>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#565f69]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='https://drive.google.com/file/d/1yfScPinZ0tSb0nrjTIGKTktfUEh32V_1/view?usp=sharing'
            >
              Resume <BsFillPersonLinesFill size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
